import createClient, { type Middleware } from 'openapi-fetch';

import { exigerDoubleAuth, expireSession, getAccessToken } from '../auth/session';
import { API_URL } from '../lib/env';

import { fetchApi } from './network';
import type { paths } from './schema';

/**
 * Client typé des routes admin, généré depuis apps/backend/openapi/admin.yaml
 * (`npm run api:types`). Ajoute un jeton frais à chaque appel ; un 401 ferme
 * la session ; un 403 « code de double authentification exigé » renvoie à
 * l'écran de connexion pour saisir le code (ou activer la double authentification).
 */
const authentification: Middleware = {
  async onRequest({ request }) {
    const jeton = await getAccessToken();
    if (jeton) request.headers.set('Authorization', `Bearer ${jeton}`);
    return request;
  },
  async onResponse({ response }) {
    if (response.status === 401) expireSession();
    if (response.status === 403) {
      const corps: unknown = await response
        .clone()
        .json()
        .catch(() => null);
      const code = corps && typeof corps === 'object' && 'code' in corps ? corps.code : null;
      if (code === 'MFA_REQUIRED' || code === 'MFA_SETUP_REQUIRED') exigerDoubleAuth(code);
    }
    return response;
  },
};

export const api = createClient<paths>({ baseUrl: API_URL, fetch: fetchApi });
api.use(authentification);
